import Button from './_button.js'
import Image from './_image.js'
import Text from './_text.js'
import FlexPane from './_flex-pane.js'
import Tooltip from './_tooltip.js'

export default {
  name: 'ShareDialogFooter',
  values: {
    shareLink: false,
    _mobile_shareLink: true,
    _native_mobile_shareLink: false,
    shareScreenshot: false,
    _mobile_shareScreenshot: true,
    _native_mobile_shareScreenshot: false,
    linkCopiedToastDuration: 3,
    imageOptions: {
      skipFonts: true,
      quality: 0.8,
    },
    rootElementId: 'shareDialogFooterCntr',
    imageLoadTimeoutForScreenshot: 5000,
    linkButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            minHeight: '100%',
            alignItems: 'center',
            userSelect: 'none',
          },
        },
      },
    },
    linkButtonIcon: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    linkButtonIconDisabled: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    linkButtonIconHover: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    buttonLabel: {
      configSet: Text,
      configValues: {},
    },
    innerContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexGrow: '0',
          flexDirection: 'row',
        },
      },
    },
    screenshotButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            minHeight: '100%',
            alignItems: 'center',
            userSelect: 'none',
          },
        },
      },
    },
    screenshotButtonIcon: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    screenshotButtonIconHover: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    copyLinkTooltip: {
      configSet: Tooltip,
      configValues: {
        showCloseButton: false,
        popup: {
          container: {
            style: {
              width: '104px',
              bottom: '63px',
              left: '40px',
            },
          },
          arrowheadOffset: '40px',
        },
        textLabel: {
          style: {
            whiteSpace: 'nowrap',
          },
        },
      },
    },
    shareBetFooter: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          padding: '16px',
          justifyContent: 'center',
          _desktop_flexGrow: 0,
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
